'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _withSpacing = require('../withSpacing');

var _withSpacing2 = _interopRequireDefault(_withSpacing);

var _withLayout = require('../withLayout');

var _withLayout2 = _interopRequireDefault(_withLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var styles = {
  'wrapper': 'tcl__LayoutBox-832894ed'
};

/**
 * General purpose container with spacing and layout helpers. Drop in
 * replacement for a basic div.
 */

var LayoutBox = function LayoutBox(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ['className', 'children']);

  return _react2.default.createElement(
    'div',
    _extends({}, props, { className: (0, _classnames2.default)(styles.wrapper, className) }),
    children
  );
};

LayoutBox.displayName = 'LayoutBox';
LayoutBox.propTypes = _extends({}, _withLayout.propTypes, _withSpacing.propTypes);

exports.default = (0, _withLayout2.default)((0, _withSpacing2.default)(LayoutBox));